import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "navbar is-dark" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "navbar-brand" }, [
  /*#__PURE__*/_createVNode("img", {
    id: "image-logo",
    src: "https://resources.public.infigosoftware.rocks/logo/infigo-logo-white.svg",
    alt: "Infigo Logo",
    height: "100px",
    width: "100px",
    class: "sl-image"
  })
], -1)
const _hoisted_3 = {
  id: "navbarMenu",
  class: "navbar-menu"
}
const _hoisted_4 = { class: "navbar-start" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Setup")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Design a job")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Shopping Cart")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Iframe documentation")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("nav", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          to: "/setup",
          class: "navbar-item"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/product",
          class: "navbar-item"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/shopping-list",
          class: "navbar-item"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/documentation",
          class: "navbar-item"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ])
  ]))
}